import { COMMUNICATIONS_ERROR, COMMUNICATIONS_IN_PROGRESS, COMMUNICATIONS_SUCCESS } from "../actions/communications";
import buildReducer from "./build-reducer";
import { fromJS, Map } from "immutable";

let reducers = {};

reducers[COMMUNICATIONS_IN_PROGRESS] = (state, { id }) =>
  state
    .setIn([id, "state"], "in progress")
    .deleteIn([id, "error"]);

reducers[COMMUNICATIONS_ERROR] = (state, { id, error }) =>
  state
    .setIn([id, "state"], "error")
    .setIn([id, "error"], fromJS(error));

reducers[COMMUNICATIONS_SUCCESS] = (state, { id }) =>
  state
    .setIn([id, "state"], "success")
    .deleteIn([id, "error"]);

export default buildReducer(Map(), reducers);
